<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="search-suggestions">
    <span
      class="is-sr-only"
      role="status"
      aria-live="polite"
      :aria-label="querySuggestionAlternativeText"
    />
    <div
      v-show="loading"
      class="loading-icon"
    />
    <ul
      v-show="!loading"
      :id="`list-${id}`"
      role="listbox"
    >
      <template v-if="showSuggestions">
        <li
          v-for="(suggestion, i) in suggested"
          v-show="suggestion && suggestion.name"
          :key="i"
        >
          <a
            class="suggested-item"
            :href="suggestion.searchUrl"
            role="option"
            @click="pushTagging(suggestion.nameStripped || suggestion.name)"
          >
            <svg
              aria-hidden="true"
              class="icon search icon--sm"
              viewBox="0 0 100 100"
            >
              <use xlink:href="#search" />
            </svg>
            <div class="suggested-item__name">
              <span v-html="suggestion.name" />
            </div>
            <div
              v-if="suggestion.count"
              class="suggested-item__count"
            >
              {{ suggestion.count }}
            </div>
          </a>
        </li>
      </template>

      <ul
        v-if="showProductSuggestions || showClpSuggestions"
        class="search-suggestions__list"
      >
        <div class="search-suggestions__list-label">
          {{ productListLabel }}
        </div>
        <li
          v-for="(suggestion, i) in suggestedProducts"
          v-show="suggestion && suggestion.name"
          :key="i"
        >
          <a
            class="suggested-item suggested-item--product"
            :href="suggestion.pdpUrl"
            role="option"
            @click="pushTagging(suggestion.nameStripped || suggestion.name)"
          >
            <img
              v-srcset="suggestion.image.srcset"
              :alt="suggestion.image.alt"
              class="thumbnail"
              src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
            >
            <div class="suggested-item__name">
              <span v-html="suggestion.name" />
            </div>
            <div
              v-if="suggestion.count"
              class="suggested-item__count"
            >
              {{ suggestion.count }}
            </div>
          </a>
        </li>

        <li
          v-for="(suggestion, i) in suggestedClp"
          v-show="suggestion && suggestion.name"
          :key="i"
        >
          <a
            class="suggested-item suggested-item--clp"
            :href="suggestion.clpUrl"
            role="option"
            @click="pushTagging(suggestion.nameStripped || suggestion.name)"
          >
            <div class="suggested-item__name">
              <span v-html="suggestion.name" />
            </div>
            <div
              v-if="suggestion.count"
              class="suggested-item__count"
            >
              {{ suggestion.count }}
            </div>
          </a>
        </li>
      </ul>

      <ul
        v-if="showArticleSuggestions"
        class="search-suggestions__list search-suggestions__list--articles"
      >
        <div class="search-suggestions__list-label">
          {{ articleListLabel }}
        </div>
        <li
          v-for="(suggestion, i) in suggestedArticles"
          v-show="suggestion && suggestion.name"
          :key="i"
        >
          <a
            class="suggested-item suggested-item--article"
            :href="suggestion.articleUrl"
            role="option"
            @click="pushTagging(suggestion.nameStripped || suggestion.name)"
          >
            <div class="suggested-item__name">
              <span v-html="suggestion.name" />
            </div>
          </a>
        </li>
      </ul>
    </ul>
  </div>
</template>

<script>
  import { AnalyticsHandler } from '@/Foundation/Common/code/Scripts/analyticsHandler';
  import { tag } from '@Foundation/analyticsHandler/directives/tag';
  import { srcset } from '@Foundation/directives/srcset/srcset';

  export default {
    name: 'SearchSuggestions',
    directives: {
      tag,
      srcset,
    },
    props: {
      suggested: { type: Array, required: true },
      suggestedProducts: { type: Array, required: true },
      suggestedClp: { type: Array, required: true },
      suggestedArticles: { type: Array, required: true },
      term: { type: String, required: false, default: '' },
      id: { type: String, required: true },
      querySuggestionAlternativeText: { type: String, required: true },
      loading: { type: Boolean, required: true },
      productListLabel: { type: String, required: false, default: 'Products' },
      articleListLabel: { type: String, required: false, default: 'Articles' },
    },
    computed: {
      showSuggestions() {
        return (
          !this.loading &&
          this.suggested.length > 0 &&
          this.suggestedProducts.filter(e => e !== null).length > 0
        );
      },
      showProductSuggestions() {
        return (
          !this.loading &&
          this.suggestedProducts.length > 0 &&
          this.suggestedProducts.filter(e => e !== null).length > 0
        );
      },
      showClpSuggestions() {
        return (
          !this.loading &&
          this.suggestedClp.length > 0 &&
          this.suggestedClp.filter(e => e !== null).length > 0
        );
      },
      showArticleSuggestions() {
        return (
          !this.loading &&
          this.suggestedArticles.length > 0 &&
          this.suggestedArticles.filter(e => e !== null).length > 0
        );
      },
    },

    methods: {
      pushTagging(searchTerm) {
        AnalyticsHandler.pushDataLayer({
          ecommerce: undefined,
          event: 'uaevent',
          eventAction: 'search::autocompletion',
          eventCategory: 'internal search',
          eventLabel: searchTerm,
          event_name: 'internal_search',
          method: 'autocompletion',
          search_keyword: searchTerm,
        });
      },
    },
  };
</script>
